export default "__VITE_ASSET__BN3ZUyA8__"